

import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { ConfirmationService, MessageService } from "primeng/api";


  import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";


  import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { Subject } from "rxjs";
  import { HttpClient } from "@angular/common/http";
import { StoricoPratica } from "src/app/models/pratica.storico.model";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";
import { ExcelService } from "src/app/services/excelService.service";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";


@Component({
    selector: "app-storico-pratica",
    templateUrl: './storico-pratica.component.html',
    styleUrls: ["../shared.component.css"],
  })
  export class StoricoPraticaComponent implements OnInit {


    protected _onDestroy = new Subject<void>();

    protected storico:StoricoPratica[]=[];
    protected pratica: PraticaFlowdy2_Firestore;
    protected fase:number = 1;

    protected ref: DynamicDialogRef;
    isLoadingResults = false;

    constructor(
        private logger: NGXLogger,
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public confirmationService:ConfirmationService,
        public dialogService: DialogService,
        private stiliService:StiliService ,
        private utilService:UtilService,
        private excelService:ExcelService
      ) {

      this.storico = this.config.data.storicoPratica;
      this.pratica = this.config.data.pratica;
      this.fase = this.config.data.fase;
    }

   
    ngOnInit(): void {



    }
   
    formattaStorico(storico:StoricoPratica):string{
      return storico.statoFlowdy.codice.toString();
    }

    scaricaReportStorico(){
      if(this.fase === 1){
        this.excelService.exportStoricoToExcel(this.storico, 'storico_fase1_'+this.pratica.cui+'.xlsx');
      }else if(this.fase === 2){
        this.excelService.exportStoricoToExcel(this.storico, 'storico_fase2_'+this.pratica.cui+'.xlsx');
      }else if(this.fase === 3){
        this.excelService.exportStoricoToExcel(this.storico, 'storico_fase3_'+this.pratica.cui+'.xlsx');
      } }
    
  }
